<template>
  <ExpandableSection
    :title="title"
    v-model="modelValue"
  >
    <v-container>
      <v-row>
        <Field :label="prefix + ' Group'" :value="item[code]" />
        <Field :label="prefix + ' Dept'" :value="item[dept]" />
        <Field :label="prefix + ' Status'" :value="item[status]" />
        <Field :label="prefix + ' Target'" :value="item[target]" />
        <Field :label="prefix + ' Delay'" :value="item[delay]" />
      </v-row>
    </v-container>
  </ExpandableSection>
</template>

<script>
import ExpandableSection from "./ExpandableSection.vue"

export default {
  components: { ExpandableSection },

  props: {
    item: Object,
    type: String,
    title: String,
    modelValue: Boolean
  },

  computed: {
    prefix() {
      return this.type === "1" ? "1st" : "2nd"
    },
    code() {
      return this.type === "1" ? "codeNm" : "codeNm2"
    },
    dept() {
      return this.type === "1" ? "deptNm1" : "deptNm2"
    },
    status() {
      return this.type === "1" ? "statNm1" : "statNm2"
    },
    target() {
      return this.type === "1" ? "trgtDt" : "trgtDt2"
    },
    delay() {
      return this.type === "1" ? "dlyNm1" : "dlyNm2"
    }
  },

  components: {
    Field: {
      props: ["label", "value"],
      template: `
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-text-field
            :label="label"
            :value="value"
            dense
            readonly
          />
        </v-col>
      `
    }
  }
}
</script>